import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BaseAppState } from '../../../../core/store/reducers';
import { UsersSelectors } from '../../../../core/users/selectors/users-selectors';
import { USER_UI_PATHS } from '../../../../core/users/definitions/user-ui-navigation.definitions';
import { UserApiActions } from '../../../../core/users/actions/user-api.actions';
import { combineLatest, filter, Observable, takeUntil } from 'rxjs';
import { UserListItem } from '../../../../shared/models';
import { ObservableComponent } from 'ngx-esprio-shared';
import { AuthSelectors } from '../../../../core/auth/selectors/auth.selectors';
import { SubmissionApiActions } from '../../../../core/users/actions/user-submissions-api.actions';
import { UserDataApiActions } from '../../../../core/users/actions/user-data-api.actions';

@Component({
  selector: 'app-user-details-modal',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss'],
})
export class UserDetailsComponent extends ObservableComponent implements OnInit, OnDestroy {
  constructor(
    private store: Store<BaseAppState>,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super();
  }

  public selectedUser$: Observable<UserListItem | undefined>;
  public selectedTab = 0;

  private loggedInUser$ = this.store.select(AuthSelectors.getLoggedInUser);

  ngOnInit(): void {
    combineLatest([this.store.select(UsersSelectors.getisUsersFetched), this.loggedInUser$])
      .pipe(filter(([isFetched, user]) => Boolean(!isFetched && !!user)))
      .subscribe(([_, user]) => {
        this.store.dispatch(UserApiActions.getMonitoredUsers({ userId: user!.id }));
      });

    this.setSelectedUserId();

    combineLatest([this.store.select(UsersSelectors.getSelectedUserId), this.loggedInUser$])
      .pipe(
        filter(([selectedUserId, loggedInUser]) => !!selectedUserId && !!loggedInUser),
        takeUntil(this.ngDestroy$)
      )
      .subscribe(([selectedUserId, loggedInUser]) => {
        this.store.dispatch(
          SubmissionApiActions.loadLatestSubmissionDetails({
            userId: loggedInUser!.id,
            monitoredUserId: selectedUserId as string,
          })
        );

        this.store.dispatch(
          UserDataApiActions.getUserScoreDetails({
            userId: loggedInUser!.id,
            monitoredUserId: selectedUserId as string,
          })
        );
      });
  }

  private setSelectedUserId() {
    this.route.paramMap.pipe(takeUntil(this.ngDestroy$)).subscribe((params) => {
      const userId = params.get('id');
      if (userId) {
        this.store.dispatch(UserApiActions.setSelectedUserId({ userId }));
        this.selectedUser$ = this.store.select(UsersSelectors.getSelectedUser);
      }
    });
  }

  public onBack() {
    this.clearSelectedUserState();
    this.router.navigate([USER_UI_PATHS.root.users]);
  }

  public goBack() {
    this.router.navigate([USER_UI_PATHS.root.users]);
  }

  private clearSelectedUserState() {
    this.store.dispatch(UserApiActions.setSelectedUserId({ userId: '' }));
    this.store.dispatch(UserApiActions.purgeUserDetails());
    this.store.dispatch(UserDataApiActions.purgeUserData());
    this.store.dispatch(SubmissionApiActions.clearSubmissionDetails());
  }
}
